import React, { createContext, useState, useContext, useEffect } from "react";

export const SidebarContext = createContext();

// Same rule as handleResize below, applied before the first paint. Starting from `false` and
// correcting it in an effect made the content's margin animate open after the page had drawn
// (a 0.4–0.5 layout shift on desktop).
const initialSidebar = () => {
  if (window.innerWidth < 1024) return false;
  try {
    const saved = localStorage.getItem("diilSidebar");
    return saved === null ? true : saved === "true";
  } catch {
    return true;
  }
};

export const SidebarProvider = ({ children }) => {
  const [sidebar, setSidebar] = useState(initialSidebar);
  // Whether the mobile Home filter block (profession/salary/level/type) is revealed.
  // Hidden by default; opened when the user taps the search bar.
  const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        const saved = localStorage.getItem("diilSidebar");
        if (saved !== null) {
          setSidebar(saved === "true");
        } else {
          setSidebar(true);
        } 
      } else {
        setSidebar(false);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Only a desktop state is the user's choice. Below 1024 handleResize forces it closed, and
  // persisting that would collapse the sidebar for good the next time the window got wider.
  useEffect(() => {
    if (window.innerWidth < 1024) return;
    try {
      localStorage.setItem("diilSidebar", sidebar);
    } catch {
      /* private mode — the sidebar just opens in its default state next time */
    }
  }, [sidebar]);

  return (
    <SidebarContext.Provider value={{ sidebar, setSidebar, mobileFiltersOpen, setMobileFiltersOpen }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
